import { Upload, message, Button } from 'antd'
import { UploadOutlined } from '@ant-design/icons'
import React from 'react';


const defProps = {
    name: 'file',
    accept: '.csv',
    showUploadList: false,

}

const FileUploadBox = (props) => {
    const actions = {...props, ...defProps}

    return (
        <Upload {...actions}>
        <Button>
            <UploadOutlined /> Click to Upload
        </Button>
    </Upload>
    )
}

export default FileUploadBox